import { Box, ListItem, Text, UnorderedList } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ExclusionGroundsSummary } from "../ExclusionGroundsSummary";
import type { ExclusionGroundsSummaryData } from "../summary/QualificationSection";
import { EspdGuidingMessage } from "./EspdGuidingMessage";
import { EspdPreviewPart } from "./EspdPreviewPart";

interface Props {
  summary: ExclusionGroundsSummaryData;
}

export const EspdPreviewDelIII = ({ summary }: Props) => {
  const { t, i18n } = useTranslation();
  const isNorwegian = i18n.language.startsWith("no");
  const { disabledVoluntaryCriteria, ...counts } = summary;
  const hasDisabled = disabledVoluntaryCriteria.length > 0;

  return (
    <EspdPreviewPart eyebrow={t("Part III")} title={t("Exclusion grounds")} owner="buyer">
      <EspdGuidingMessage>
        {t("The supplier will be asked to confirm that none of the following exclusion grounds apply to them.")}
      </EspdGuidingMessage>
      <ExclusionGroundsSummary {...counts} />
      {hasDisabled && (
        <Box mt="4">
          <Text fontSize="sm" mb="2">
            {t("The following voluntary grounds are not active:")}
          </Text>
          <UnorderedList spacing="1" pl="5">
            {disabledVoluntaryCriteria.map((c) => (
              <ListItem key={c.id} fontSize="sm">
                {isNorwegian ? c.nameNorwegian ?? c.name : c.name}
              </ListItem>
            ))}
          </UnorderedList>
        </Box>
      )}
    </EspdPreviewPart>
  );
};
